import * as languages from "./constants/languages";
import AccessibleClassPage from "./components/pages/AccessibleClassPage";
import CatalogPage from "./components/pages/CatalogPage";
import ClassPage from "./components/pages/ClassPage";
import CustomerSatisfactionSurveyPage from "./components/pages/CustomerSatisfactionSurveyPage";
import FAQPage from "./components/pages/FAQPage";
import LoginPage from "./components/pages/LoginPage";
import MyClassesPage from "./components/pages/MyClassesPage";
import ThankYouPage from "./components/pages/ThankYouPage";
import SignUpPage from "./components/pages/SignUpPage";
import LiveClassCompletePage from "./components/pages/LiveClassCompletePage";
import React, { Component } from "react";
import { Route, Router, Redirect, browserHistory } from "react-router";
import "react-notifications/lib/notifications.css";
import CertificateQuestionPage from "./components/pages/CertificateQuestionPage";
import LiveCalendarPage from "./components/pages/LiveCalendarPage";
import { me } from "./api/account";

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loggedIn: false,
		};
	}

	componentDidMount() {
		this.userIsAuthenticated()
			.then(loggedIn => {
				this.setState({ loggedIn });
			})
			.catch(err => {
				console.warn(err);
			});
	}

	checkUser = async (nextState, replace) => {
		try {
			const loggedIn = await this.userIsAuthenticated();
			if (!loggedIn) {
				// TODO redirectpath
				const query = {
					redirectpath:
						nextState.location.pathname || nextState.location.search
							? encodeURIComponent(
									`${nextState.location.pathname}${nextState.location.search}`,
								)
							: "",
				};
				if (
					nextState.location.query.language === languages.en ||
					nextState.location.query.language === languages.es
				) {
					query.language = nextState.location.query.language;
				}
				replace({
					pathname: "/login",
					query,
				});
			}
		} catch (e) {
			replace({
				pathname: "/login",
			});
		}
	};

	languageFromUrl = routeParams => {
		const language =
			routeParams.location.query.language === languages.en ||
			routeParams.location.query.language === languages.es
				? routeParams.location.query.language
				: languages.en;
		return language;
	};

	sessionIdFromUrl = routeParams => {
		return routeParams.location.query.session;
	};

	userIsAuthenticated = async () => {
		try {
			await me();
			return true;
		} catch (err) {
			return false;
		}
	};

	render() {
		return (
			<Router history={browserHistory}>
				<Route
					path="/my-classes"
					component={routeParams => (
						<MyClassesPage
							pathname={routeParams.location.pathname}
							params={routeParams.params}
							language={
								routeParams.location.query.language === languages.en ||
								routeParams.location.query.language === languages.es
									? routeParams.location.query.language
									: languages.en
							}
						/>
					)}
					onEnter={this.checkUser}
				/>
				<Route
					path="/catalog"
					component={routeParams => (
						<CatalogPage
							pathname={routeParams.location.pathname}
							params={routeParams.params}
							language={
								routeParams.location.query.language === languages.en ||
								routeParams.location.query.language === languages.es
									? routeParams.location.query.language
									: languages.en
							}
						/>
					)}
					onEnter={this.checkUser}
				/>
				<Route
					path="/catalog/live"
					component={routeParams => (
						<LiveCalendarPage
							pathname={routeParams.location.pathname}
							params={routeParams.params}
							language={
								routeParams.location.query.language === languages.en ||
								routeParams.location.query.language === languages.es
									? routeParams.location.query.language
									: languages.en
							}
							loggedIn={this.state.loggedIn}
						/>
					)}
				/>
				<Route
					path="/class/:class_id/accessible"
					component={routeParams => (
						<AccessibleClassPage
							pathname={routeParams.location.pathname}
							classId={routeParams.params.class_id}
							email={routeParams.location.query.email}
							language={
								routeParams.location.query.language === languages.en ||
								routeParams.location.query.language === languages.es
									? routeParams.location.query.language
									: languages.en
							}
						/>
					)}
				/>
				<Route
					path="/class/:class_id"
					component={routeParams => (
						<ClassPage
							pathname={routeParams.location.pathname}
							params={routeParams.params}
							language={this.languageFromUrl(routeParams)}
							loggedIn={this.state.loggedIn}
						/>
					)}
				/>
				<Route
					path="/faq"
					component={routeParams => (
						<FAQPage
							pathname={routeParams.location.pathname}
							params={routeParams.params}
							loggedIn={this.state.loggedIn}
							language={
								routeParams.location.query.language === languages.en ||
								routeParams.location.query.language === languages.es
									? routeParams.location.query.language
									: languages.en
							}
						/>
					)}
				/>
				{this.state.loggedIn ? (
					<Redirect from="/complete/:class_id" to="/post-complete/:class_id" />
				) : (
					<Route
						path="/complete/:class_id"
						component={routeParams => (
							<LiveClassCompletePage
								pathname={routeParams.location.pathname}
								params={routeParams.params}
								sessionId={this.sessionIdFromUrl(routeParams)}
								language={this.languageFromUrl(routeParams)}
							/>
						)}
					/>
				)}
				<Route
					path="/post-complete/:class_id"
					component={routeParams => (
						<CertificateQuestionPage
							pathname={routeParams.location.pathname}
							params={routeParams.params}
							language={this.languageFromUrl(routeParams)}
							loggedIn={this.state.loggedIn}
							sessionId={this.sessionIdFromUrl(routeParams)}
						/>
					)}
				/>
				<Route
					path="/survey/:class_id"
					component={routeParams => (
						<CustomerSatisfactionSurveyPage
							pathname={routeParams.location.pathname}
							params={routeParams.params}
							certificate={routeParams.location.query.certificate}
							sessionId={this.sessionIdFromUrl(routeParams)}
							loggedIn={this.state.loggedIn}
							language={
								routeParams.location.query.language === languages.en ||
								routeParams.location.query.language === languages.es
									? routeParams.location.query.language
									: languages.en
							}
						/>
					)}
				/>
				<Route
					path="/login"
					component={routeParams => (
						<LoginPage
							pathname={routeParams.location.pathname}
							params={routeParams.params}
							language={
								routeParams.location.query.language === languages.en ||
								routeParams.location.query.language === languages.es
									? routeParams.location.query.language
									: languages.en
							}
							redirectPath={
								decodeURIComponent(routeParams.location.query.redirectpath) !==
								"undefined"
									? decodeURIComponent(routeParams.location.query.redirectpath)
									: null
							}
						/>
					)}
				/>
				<Route
					path="/signup"
					component={routeParams => (
						<SignUpPage
							pathname={routeParams.location.pathname}
							params={routeParams.params}
							language={
								routeParams.location.query.language === languages.en ||
								routeParams.location.query.language === languages.es
									? routeParams.location.query.language
									: languages.en
							}
							redirectPath={
								decodeURIComponent(routeParams.location.query.redirectpath) !==
								"undefined"
									? decodeURIComponent(routeParams.location.query.redirectpath)
									: null
							}
						/>
					)}
				/>
				<Route
					path="/thanks"
					component={routeParams => (
						<ThankYouPage
							pathname={routeParams.location.pathname}
							params={routeParams.params}
							language={
								routeParams.location.query.language === languages.en ||
								routeParams.location.query.language === languages.es
									? routeParams.location.query.language
									: languages.en
							}
							redirectPath={
								decodeURIComponent(routeParams.location.query.redirectpath) !==
								"undefined"
									? decodeURIComponent(routeParams.location.query.redirectpath)
									: null
							}
						/>
					)}
				/>
				<Redirect from="*" to="/catalog" />
			</Router>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js